import { memo } from "react";
import {
  Alert,
  Box,
  Grid,
  IconButton,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
} from "@mui/material";
import LoadingComponent from "../components/LoadingComponent";
import TableLoader from "../components/TableLoader";
import AdminActions from "../components/AdminActions";
import { useNavigate } from "react-router-dom";
import { useAdmins } from "../hooks/useAdmins.jsx";

function MyAdmins() {
  const navigate = useNavigate();
  const {
    admins,
    adminsCount,
    loading,
    error,
    pagination,
    auxSearcher,
    handleChangePage,
    handleChangeRowsPerPage,
    setAuxSearcher,
  } = useAdmins();

  const handleTablePageChange = (event, newPage) => {
    handleChangePage(newPage + 1);
  };

  const handleRowsPerPageChange = (event) => {
    handleChangeRowsPerPage(parseInt(event.target.value, 10));
  };

  return (
    <>
      {loading ? <LoadingComponent /> : null}
      {error ? (
        <Alert sx={{ borderRadius: "0px !important" }} severity="error">
          {error}
        </Alert>
      ) : null}
      <Grid item xs={12} className="mg-t-20">
        <h2>Mis Admins</h2>
      </Grid>
      <AdminActions auxSearcher={auxSearcher} setAuxSearcher={setAuxSearcher} />

      <Grid container>
        <Grid container className="custom-table-container">
          <Grid item xs={12} className="flex-center mg-t-0">
            <>
              <TableContainer>
                {loading ? (
                  <TableLoader />
                ) : (
                  <Table aria-label="tabla de admins" className="fixed-table">
                    <TableHead sx={{ backgroundColor: "#fff" }}>
                      <TableRow>
                        <TableCell sx={{ fontWeight: "bold" }}></TableCell>
                        <TableCell sx={{ fontWeight: "bold" }}>Nombre</TableCell>
                        <TableCell sx={{ fontWeight: "bold" }}>Email</TableCell>
                        <TableCell sx={{ fontWeight: "bold" }}>Rut</TableCell>
                        <TableCell sx={{ fontWeight: "bold" }}>Plan</TableCell>
                        <TableCell sx={{ fontWeight: "bold" }}>País</TableCell>
                        <TableCell sx={{ fontWeight: "bold" }}>Creación</TableCell>
                        <TableCell sx={{ fontWeight: "bold" }}>Último Login</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {admins.map((admin) => (
                        <TableRow
                          key={admin.id}
                          hover
                          sx={{
                            "& > *": { borderBottom: "unset" },
                            backgroundColor: "#fff",
                          }}
                        >
                          <TableCell component="th" scope="row">
                            <IconButton onClick={() => navigate(`/home/admin/${admin.id}`)}>
                              <i className="material-icons">add</i>
                            </IconButton>
                          </TableCell>
                          <TableCell>
                            {`${admin.user?.first_name} ${admin.user?.last_name}`}
                          </TableCell>
                          <TableCell>{admin.user?.email}</TableCell>
                          <TableCell>{admin.rut}</TableCell>
                          <TableCell>{admin.plan_name ?? "—"}</TableCell>
                          <TableCell>{admin.country_fk?.name ?? "—"}</TableCell>
                          <TableCell>
                            {admin.created_at
                              ? new Date(admin.created_at).toLocaleDateString()
                              : "—"}
                          </TableCell>
                          <TableCell>
                            {admin.user?.last_login
                              ? new Date(admin.user.last_login).toLocaleDateString()
                              : "—"}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                )}

                {!loading && admins.length === 0 && (
                  <Box sx={{ p: 4, textAlign: "center" }}>
                    <Typography color="text.secondary">
                      No se encontraron admins.
                    </Typography>
                  </Box>
                )}

                <TablePagination
                  rowsPerPageOptions={[20, 40, 60, 80, 100]}
                  component="div"
                  count={adminsCount}
                  rowsPerPage={pagination.rowsPerPage}
                  page={pagination.page - 1}
                  onPageChange={handleTablePageChange}
                  onRowsPerPageChange={handleRowsPerPageChange}
                />
              </TableContainer>
            </>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

export default memo(MyAdmins);
